// normally these flags are set via a script but for consistency we have a
// reducer here as well.
export default (state = {}, action)=> {
  switch (action.type) {

  default: {
    return state;
  }

  }
};
